<template>
  <div class="p-0">
    <div class="col-xs-12 p-0 font-14 color-light-black">Preview</div>
    <div class="col-xs-12 p-10 preview-wrapper mt-5 mb-30">
      <div class="content-holder col-xs-12 pl-0">
        <div class="col-xs-12 p-0 mb-20">
          <strong class="font-14 bg-black">Title:</strong>
          <div class="font-16 font-300 mb-0 title-wrapper" v-html="alertDetails.title"></div>
        </div>
        <div class="col-xs-12 p-0 mb-30">
          <strong class="font-14 bg-black">Country:</strong>
          <div class="font-16 font-300">{{ alertDetails.countryName }}</div>
        </div>
        <div class="col-xs-12 p-0 mb-30">
          <strong class="font-14 bg-black">Effective Date:</strong>
          <div class="font-16 font-300">
            {{ alertDetails.regulatoryEffectiveDate | dateFormatter }}
          </div>
        </div>
        <div class="col-xs-12 p-0 mb-30">
          <strong class="font-14 bg-black">Description:</strong>
          <div
            id="description"
            class="font-16"
            v-html="alertDetails.description.replace(/\n/g, '<br/>')"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['alertDetails'],
  filters: {
    dateFormatter(date) {
      return date ? moment(date).format('DD/MM/YYYY') : 'Date Not Selected';
    }
  }
};
</script>

<style lang="scss" scoped>
.color-light-black {
  color: rgba(0, 0, 0, 0.7);
}

/* .mb-30 {
	margin-bottom: 30px;
} */

.bg-black {
  color: rgba(0, 0, 0, 0.7);
}

.font-300 {
  font-weight: $font-weight-small;
}

.preview-wrapper {
  background: $deep-white;
  border: 1px solid $deep-gray;
  box-sizing: border-box;
  border-radius: 3px;
}

.content-holder {
  min-height: 50vh;
  max-height: 70vh;
  overflow: auto;
  scrollbar-width: thin;
}

.title-wrapper {
  > p {
    margin-bottom: 0px;
  }
}
</style>
